module.exports = __webpack_public_path__ + "static/und-vilhena-8a37d5cf6f6de73268100c089f78a9e2.png";